<script lang="ts">
  import type { ListComponentProps } from './types';

  type $$Props = ListComponentProps;

  export let entryId: ListComponentProps['entryId'];
  export let columnCount: ListComponentProps['columnCount'];
  export let listMarkerColor: ListComponentProps['listMarkerColor'];
  export let listElementType: ListComponentProps['listElementType'];
  export let listItems: ListComponentProps['listItems'];
  export let listType: ListComponentProps['listType'];
  export let style: ListComponentProps['style'];
  export let customCssClass: ListComponentProps['customCssClass'];
</script>

<div
  class="ListComponent ListComponent-{entryId}-box-properties {customCssClass}"
  data-entry-id={entryId}
  style:--list-marker-color={`var(${listMarkerColor})`}
>
  <svelte:element this={listElementType} class="num-cols-{columnCount} {listType} {style}">
    {#each listItems as listItem}
      <li class="ListComponentItem">
        {@html listItem}
      </li>
    {/each}
  </svelte:element>
</div>

<style lang="scss">
  @use '@squareup/public-web-design-system/dist/styles/xms-fe/mixins/grid.scss' as grid;

  .ListComponent {
    width: 100%;
  }

  .num-cols-1 {
    @include grid.columns(1);
    @include grid.space-row(10);
  }

  .num-cols-2 {
    @include grid.columns(1);
    @include grid.columns(2, $at: 'medium');
    @include grid.space(20);
  }

  .num-cols-3 {
    @include grid.columns(1);
    @include grid.columns(2, $at: 'small');
    @include grid.columns(3, $at: 'large');
    @include grid.space(20);
  }

  ol {
    counter-reset: listCounter;
  }
  li {
    margin-bottom: 0;
  }
  li::before {
    color: var(--list-marker-color);
  }
  ul.bullet > li::before {
    content: '•';
  }
  ul.checkmark > li::before {
    content: ' ';
    width: 1em;
    height: 0.5em;
    top: 0.5em;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    border-style: solid;
    border-top-width: 0;
    border-right-width: 0;
    border-left-width: 0.125em;
    border-bottom-width: 0.125em;
  }
  ol.decimal > li::before {
    counter-increment: listCounter;
    content: counter(listCounter, decimal) '. ';
  }
  ol.lower-alpha > li::before {
    counter-increment: listCounter;
    content: counter(listCounter, lower-alpha) '. ';
  }
  ol.lower-roman > li::before {
    counter-increment: listCounter;
    content: counter(listCounter, lower-roman) '. ';
  }
  .reset {
    list-style-type: none;
    padding: 0;
  }
  ol.upper-alpha > li::before {
    counter-increment: listCounter;
    content: counter(listCounter, upper-alpha) '. ';
  }
  ol.upper-roman > li::before {
    counter-increment: listCounter;
    content: counter(listCounter, upper-roman) '. ';
  }

  .ListComponentItem {
    :global(p) {
      margin-bottom: 0;
    }
  }
</style>
